import React from 'react';

interface Props {
  /** 0–100 */
  value: number;
  label?: string;
  sub?: string;
  /** stroke color (token or currentColor) */
  color?: string;
  size?: number;
}

/** SVG donut with a centered percentage label. */
const Ring: React.FC<Props> = ({ value, label, sub, color = 'var(--brand-500)', size = 130 }) => {
  const stroke = 12;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, value));
  const offset = c - (clamped / 100) * c;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, width: size, maxWidth: '100%' }}>
      <svg viewBox={`0 0 ${size} ${size}`} style={{ width: '100%', height: 'auto', display: 'block', transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--bg-subtle)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset .6s ease' }}
        />
        <text
          x="50%"
          y="50%"
          dominantBaseline="central"
          textAnchor="middle"
          style={{ transform: 'rotate(90deg)', transformOrigin: 'center', fontWeight: 800, fontSize: size * 0.2, fill: 'var(--text)' }}
          className="tnum"
        >
          {label ?? `${Math.round(clamped)}%`}
        </text>
      </svg>
      {sub && <div className="dim" style={{ fontSize: 12.5, fontWeight: 600 }}>{sub}</div>}
    </div>
  );
};

export default Ring;
